import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  width: 100%;
  overflow-x: hidden;
  position: relative;
`;

function App() {
  useEffect(() => {
    // Set document title and favicon
    document.title = 'RJSpark - Data Engineering Consulting';
    
    // Update favicon if needed
    const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (favicon) {
      favicon.href = '/favicon.svg';
    }
  }, []);

  return (
    <AppContainer>
      <Header />
      <Hero />
      <Services />
      <About />
      <Contact />
    </AppContainer>
  );
}

export default App;
